export default __webpack_public_path__ + "static/media/cpr12.d0cee6fc.jpg";